import { defineStore } from 'pinia';
var useQuestionnaireStoreDefinition = defineStore('questionnaire', {
  state: function state() {
    return {
      data: null,
      standardQuestions: null
    };
  },
  getters: {
    getQuestionnaire: function getQuestionnaire(state) {
      return state.data;
    },
    getStandardQuestions: function getStandardQuestions(state) {
      return state.standardQuestions;
    }
  },
  actions: {
    setData: function setData(payload) {
      this.data = payload;
    },
    setStandardQuestions: function setStandardQuestions(payload) {
      this.standardQuestions = payload;
    }
  },
  persist: true
});

// VUE 2.7 WORKAROUND — see composables/usePinia.ts. Remove this wrapper at
// the Vue 3 flip and export useQuestionnaireStoreDefinition directly as
// useQuestionnaireStore instead.
export function useQuestionnaireStore() {
  return useQuestionnaireStoreDefinition(usePinia());
}